export default {"src":"/_next/static/media/MRVL.e36b1aff.svg","height":18,"width":18};